/**
 * A receipt can be an image or a PDF, and the two cannot be shown the same
 * way: an <img> pointed at a PDF renders a broken-image icon, not a document.
 *
 * Every place that displays a receipt asks this first, then either shows the
 * picture or offers to open the file.
 */

/**
 * Is this receipt a PDF?
 *
 * Takes either a File chosen in the browser (which carries a real MIME type)
 * or a stored URL (where only the extension is available). The query string
 * is stripped first, so a signed or cache-busted URL still reads correctly.
 */
export function isPdfReceipt(fileOrUrl) {
  if (!fileOrUrl) return false;

  if (typeof fileOrUrl !== "string") {
    if (fileOrUrl.type) return fileOrUrl.type === "application/pdf";
    return /\.pdf$/i.test(fileOrUrl.name || "");
  }

  return /\.pdf$/i.test(fileOrUrl.split("?")[0].split("#")[0]);
}

export default isPdfReceipt;
